import { useFetcher } from '@remix-run/react'
import { useEffect, useState } from 'react'
import { type loader } from '#app/routes/api+/speech.$speechId.summary'

export function SpeechSummary({ speechId }: { speechId: string }) {
  const fetcher = useFetcher<typeof loader>()
  const [isLoading, setLoading] = useState(false)

  useEffect(
    function () {
      if (!isLoading && fetcher.state === 'idle' && !fetcher.data) {
        fetcher.load(`/api/speech/${speechId}/summary`)
        setLoading(true)
      }
    },
    [speechId, fetcher, isLoading],
  )

  const speech = fetcher.data
  if (!speech) {
    return <div>Loading...</div>
  }

  return (
    <div>
      <p className="whitespace-pre-wrap">{speech.message}</p>
    </div>
  )
}
